import { z } from 'zod';
import { editionSummarySchema } from './editions.js';
import { participantKindSchema, participantSchema } from './participants.js';

/**
 * Rodzina w edycji (`GET /editions/{slug}/registration`). Bez kroku „zgłoszenie udziału” (decyzja 2026‑09‑28): każda osoba
 * z konta jest uczestnikiem konferencji. `inEdition` – osoba ma zapisy (albo odprawę) w tej edycji; `otherEdition` – ma je
 * w innej edycji tego samego dnia, więc tu zapisać się nie może (BR-17).
 */
export const registrationPersonSchema = z.object({
  participantId: z.string().uuid(),
  firstName: z.string(),
  lastName: z.string(),
  kind: participantKindSchema,
  birthYear: z.number().int().nullable(),
  isGuardian: z.boolean(),
  inEdition: z.boolean(),
  otherEdition: z.object({ name: z.string(), city: z.string() }).nullable(),
});
export type RegistrationPerson = z.infer<typeof registrationPersonSchema>;

export const registrationViewSchema = z.object({
  edition: editionSummarySchema,
  people: z.array(registrationPersonSchema),
});
export type RegistrationView = z.infer<typeof registrationViewSchema>;

// --- Obsługa (US-407) ---

export const staffAccountSchema = z.object({
  id: z.string().uuid(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  emailVerified: z.boolean(),
  participantCount: z.number().int(),
});
export type StaffAccount = z.infer<typeof staffAccountSchema>;
export const staffAccountListSchema = z.object({ accounts: z.array(staffAccountSchema) });

/** US-407 AC-1: widok konta dla obsługi – uczestnicy i aktywne edycje (oznaczenie: rodzina ma zapisy w edycji). */
export const staffAccountDetailSchema = z.object({
  account: staffAccountSchema,
  participants: z.array(participantSchema),
  editions: z.array(editionSummarySchema),
});
export type StaffAccountDetail = z.infer<typeof staffAccountDetailSchema>;

/** US-703 AC-2: „Wyślij mi plan” – adres, na który poszedł plan. */
export const planMailResultSchema = z.object({ sentTo: z.string() });
export type PlanMailResult = z.infer<typeof planMailResultSchema>;
